(function () {
  'use strict';

  // Las funciones de gráficos se definen (hoisted) más abajo dentro de este IIFE,
  // pero result.handlebars las invoca desde window.initMaturityTabCharts (ámbito
  // global). Se exponen AQUÍ ARRIBA para que ya estén disponibles cuando el
  // arranque por hash (#sector, #conclusiones) las llame durante la carga.
  window.renderClusterScatter = renderClusterScatter;
  window.renderSectorRadar    = renderSectorRadar;
  window.renderEvoBar         = renderEvoBar;

  /* ── Reveal animation ── */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ── Año en footer ── */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ════════════════════════════════════════════════════════════
     TAB NAV · resultado (result.handlebars)
     ════════════════════════════════════════════════════════════ */
  var tabBtns = document.querySelectorAll('.tab-btn');
  if (tabBtns.length) {
    var tabPanels = document.querySelectorAll('.tab-panel');

    function activateTab(id) {
      tabBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.tab === id);
      });
      tabPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === 'tab-' + id);
      });
      history.replaceState(null, '', '#' + id);
      if (typeof window.initMaturityTabCharts === 'function') {
        window.initMaturityTabCharts(id);
      }
      // Reajusta el tamaño de los gráficos ya renderizados al hacerse visible el panel
      window.dispatchEvent(new Event('resize'));
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.dataset.tab);
        var nav = document.querySelector('.tabs-nav');
        if (nav) {
          var navTop = nav.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: navTop - 8, behavior: 'smooth' });
        }
    if (btn.dataset.tab === 'sector') renderClusterScatter();
    if (btn.dataset.tab === 'conclusiones') { renderSectorRadar(); renderEvoBar(); }
    window.dispatchEvent(new Event('resize'));

      });
    });

    /* Deep-link: activar tab según hash de la URL al cargar */
    (function initFromHash() {
      var hash = (window.location.hash || '').replace('#', '').trim();
      if (hash && document.getElementById('tab-' + hash)) {
        activateTab(hash);
      }
    })();
  }

  function truncateText(text, maxLength = 20) {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  /* ════════════════════════════════════════════════════════════
     ECHARTS · radar y stages (result.handlebars)
     Lee los datos de window.MATURITY, inyectado como data island
     ════════════════════════════════════════════════════════════ */
    var radarEl = document.getElementById('radarChart');
    if (radarEl && typeof echarts !== 'undefined' && window.MATURITY) {
      const blocks        = window.MATURITY.blocks;
      const customerName  = window.MATURITY.customerName;
      const indicators    = blocks.map(function (b) { return { name: b.label, max: 4 }; });
      const values        = blocks.map(function (b) { return b.score; });
      const valuesSector  = blocks.map(function (b) { return b.sector_score; });

      //RADAR CHART
      var chart      = echarts.init(radarEl);
      chart.setOption({
        backgroundColor: 'transparent',
        legend: {
          show: true,
          bottom: 0,
          left: 'center',
          borderRadius: 2,
          textStyle: { color: '#60626f', fontSize: 12 },
          data: [truncateText(customerName,20), 'Datos sectoriales']
        },
        radar: {
          indicator: indicators,
          radius: '65%',
          splitNumber: 4,
          axisName: { color: '#60626f', fontSize: 11, lineHeight: 14 },
          splitLine:  { lineStyle: { color: 'rgba(8,11,25,.08)' } },
          splitArea:  { show: false },
          axisLine:   { lineStyle: { color: 'rgba(8,11,25,.08)' } }
        },
        series: [{
          type: 'radar',
          data: [
            {
              value: values,
              name: truncateText(customerName,20),
              areaStyle: { color: 'rgba(17,119,255,.12)' },
              lineStyle: { color: '#1177ff', width: 2 },
              itemStyle: { color: '#1177ff' },
              symbol: 'circle', symbolSize: 6
            },
            {
              value: valuesSector,
              name: 'Datos sectoriales',
              areaStyle: { color: 'rgba(255,117,95,.12)' },
              lineStyle: { color: '#ff755f', width: 2 },
              itemStyle: { color: '#ff755f' },
              symbol: 'circle', symbolSize: 6
            }
          ],
          emphasis: { disabled: true }
        }],
        tooltip: {
          trigger: 'item',
          formatter: function () {
            return indicators.map(function (ind, i) {
              return `<b>${ind.name}</b>: ${values[i]} (Sector: ${valuesSector[i]})`;
            }).join('<br>');
          }
        }
      });

      //STAGES CHART
      const stages         = window.MATURITY.stages;
      const blockLabels    = window.MATURITY.blockLabels;

      const stageChart = echarts.init(document.getElementById('stageChart'));
      stageChart.setOption({
        tooltip: {
          show: true,
          valueFormatter: function (params) {
            return blockLabels[params[0] - 1].block + ': ' + blockLabels[params[0] - 1].label;
          }
        },
        xAxis: {
          type: 'value',
          min: 1, max: 39, interval: 1,
          axisLabel: { align: 'left', color: '#c6c6c6' }
        },
        yAxis: {
          type: 'category',
          data: ['Principiante', 'Intermedio', 'Avanzado', 'Experto'],
          splitLine: { show: true },
          axisTick:  { show: false },
          axisLabel: { show: false },
          axisLine:  { lineStyle: { color: '#ccc' } }
        },
        dataset: { source: stages },
        series: {
          type: 'custom',
          renderItem: 'stage',
          colorBy: 'data',
          encode: { x: [0, 1], y: 2, tooltip: [0, 1] }
        },
        visualMap: {
          show: false,
          type: 'piecewise',
          categories: [0, 1, 2, 3],
          dimension: 2,
          inRange: {
            color: { 0: '#60626f', 1: '#ff755f', 2: '#1177ff', 3: '#222a68' }
          },
          seriesIndex: 0,
          outOfRange: { color: '#61E6E1' }
        }
      });

      window.addEventListener('resize', function () {
        chart.resize();
        stageChart.resize();
      });
    }

  // ────────────────────────────────────────────────────────────
  // Gráficos ECharts
  // ────────────────────────────────────────────────────────────
  function seededRandom(seed){ return function(){ seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }; }

  function renderClusterScatter(){
    const el = document.getElementById('clusterScatterChart');
    if (!el) return;
    if (el.dataset.rendered) { if (el._chart) el._chart.resize(); return; }
    const chart = echarts.init(el);
    const rand = seededRandom(42);
    const centers = [
      { c: CLUSTERS[0], x: 1.3, y: 1.5 },
      { c: CLUSTERS[1], x: 2.0, y: 2.2 },
      { c: CLUSTERS[2], x: 2.5, y: 2.6 },
      { c: CLUSTERS[3], x: 3.4, y: 3.6 },
    ];

    const series = centers.map(cc => ({
      name: cc.c.name,
      type: 'scatter',
      symbolSize: 9,
      itemStyle: { color: cc.c.color.replace('var(--','').replace(')','') ? getCssColor(cc.c.color) : cc.c.color, opacity: 0.55 },
      data: Array.from({ length: cc.c.count }, () => [
        clamp(cc.x + (rand() - 0.5) * 1.3, 1, 4),
        clamp(cc.y + (rand() - 0.5) * 1.3, 1, 4),
      ]),
    }));
    const opX = BLOCKS[0].you, opAvg = (BLOCKS[0].you + BLOCKS[1].you + BLOCKS[2].you + BLOCKS[7].you) / 4;
    const bizAvg = (BLOCKS[3].you + BLOCKS[4].you + BLOCKS[5].you + BLOCKS[6].you + BLOCKS[8].you + BLOCKS[9].you) / 6;
    
    series.push({
      name: 'Tu despacho',
      type: 'scatter',
      symbol: 'diamond',
      symbolSize: 20,
      itemStyle: { color: getCssColor('var(--navy)'), borderColor: '#fff', borderWidth: 2 },
      data: [[opAvg, bizAvg]],
      z: 10,
      label: { show: true, formatter: 'Tú', position: 'top', fontWeight: 700, color: getCssColor('var(--navy)') },
    });

    chart.setOption({
      grid: { left: 50, right: 24, top: 44, bottom: 52 },
      tooltip: { trigger: 'item', formatter: p => p.seriesName },
      legend: { top: 0, itemWidth: 10, itemHeight: 10, textStyle: { fontSize: 11 } },
      xAxis: { name: 'Digitalización operativa →', min: 1, max: 4, nameLocation: 'middle', nameGap: 28, splitLine: { show: true } },
      yAxis: { name: 'Digitalización de negocio →', min: 1, max: 4, nameLocation: 'middle', nameGap: 34, splitLine: { show: true } },
      series,
    });
    el.dataset.rendered = '1';
    el._chart = chart;
  }

  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }
  function getCssColor(varExpr){
    const name = varExpr.replace('var(', '').replace(')', '').trim();
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || '#1177ff';
  }

  function renderSectorRadar(){
    const el = document.getElementById('sectorRadarChart');
    if (!el) return;
    if (el.dataset.rendered) { if (el._chart) el._chart.resize(); return; }
    const chart = echarts.init(el);
    chart.setOption({
      tooltip: {},
      legend: { bottom: 0, textStyle: { fontSize: 11 } },
      radar: {
        indicator: BLOCKS.map(b => ({ name: b.name, max: 4, min: 0 })),
        radius: '62%',
        splitNumber: 4,
        axisName: { fontSize: 10, color: getCssColor('var(--muted)') },
      },
      series: [{
        type: 'radar',
        data: [
          { value: BLOCKS.map(b => b.you), name: 'Tu despacho',
            itemStyle: { color: getCssColor('var(--navy)') }, areaStyle: { opacity: 0.15 } },
          { value: BLOCKS.map(b => b.mean), name: 'Media del sector',
            itemStyle: { color: getCssColor('var(--royal)') }, lineStyle: { type: 'dashed' }, areaStyle: { opacity: 0.05 } },
          { value: BLOCKS.map(b => b.prev), name: 'Informe anterior',
            areaStyle: { color: 'rgba(255,117,95,.12)' },
            lineStyle: { color: '#ff755f', width: 2 },
            itemStyle: { color: '#ff755f' },
            symbol: 'circle', symbolSize: 6
          }
           ],
      }],
    });
    el.dataset.rendered = '1';
    el._chart = chart;
  }

  function formatMonthYear(ddateStr){ 
    const ddate = new Date(ddateStr);
    const monthName = ddate.toLocaleString('es-ES', { month: 'short' }).replace('.', '').toUpperCase();
    return `${monthName} ${ddate.getFullYear()}`
  }

  function renderEvoBar(){
    const datetime = window.MATURITY.datetime || new Date().toISOString().slice(0, 10);
    const prevDatetime = window.MATURITY.previousDatetime || 'n.a.';
    
    const el = document.getElementById('evoBarChart');
    if (!el) return;
    if (el.dataset.rendered) { if (el._chart) el._chart.resize(); return; }
    const chart = echarts.init(el);
    const names = BLOCKS.map(b => b.name);
    chart.setOption({
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      legend: { bottom: 0, textStyle: { fontSize: 11 } },
      grid: { left: 200, right: 30, top: 10, bottom: 40 },
      xAxis: { type: 'value', min: 0, max: 4 },
      yAxis: { type: 'category', data: names, axisLabel: { fontSize: 11, width: 190, overflow: 'truncate' } },
      series: [
        { name: `Informe anterior (${formatMonthYear(prevDatetime)})`, type: 'bar', data: BLOCKS.map(b => b.prev),
          itemStyle: { color: getCssColor('var(--navy)') }, barGap: '20%' },
        { name: `Informe actual (${formatMonthYear(datetime)})`, type: 'bar', data: BLOCKS.map(b => b.you),
          itemStyle: { color: getCssColor('var(--royal)') } },
      ],
    });
    el.dataset.rendered = '1';
    el._chart = chart;
  }



  /* ════════════════════════════════════════════════════════════
     FORMULARIO DE DIAGNÓSTICO (evaluate.handlebars)
     ════════════════════════════════════════════════════════════ */
  var diagForm = document.getElementById('diagForm');
  if (diagForm) {
    var questionCards = Array.prototype.slice.call(diagForm.querySelectorAll('.q-card[data-question]'));
    var blockPanels    = Array.prototype.slice.call(diagForm.querySelectorAll('.block-panel[data-block-id]'));
    var sideNavBtns    = Array.prototype.slice.call(diagForm.querySelectorAll('.side-nav-btn'));

    if (sideNavBtns.length) {
      sideNavBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sideNavBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          blockPanels.forEach(function (panel) {
            panel.classList.toggle('is-active', (panel.dataset.blockId) === btn.dataset.block);
          });
        });
      });
    }

    function getVal(name) {
      var els = document.getElementsByName(name);
      for (var i = 0; i < els.length; i++) {
        if (els[i].checked) return parseInt(els[i].value, 10);
      }
      return null;
    }

    function isAnswered(card) { return getVal(`${card.dataset.report}|${card.dataset.block}|${card.dataset.question}`) !== null; }

    function updateBlockStatus() {
      blockPanels.forEach(function (panel) {
        var cards    = Array.prototype.slice.call(panel.querySelectorAll('.q-card[data-question]'));
        var complete = cards.length > 0 && cards.every(isAnswered);
        var dot      = document.querySelector('.tab-status-dot[data-status-for="block-' + panel.dataset.blockId + '"]');
        if (dot) {
          dot.classList.toggle('is-complete', complete);
          dot.classList.toggle('is-incomplete', !complete);
        }
      });
    }

    function updateProgress() {
      var answered = questionCards.filter(isAnswered).length;
      document.getElementById('answeredCount').textContent = answered;
      var totalEl = document.getElementById('totalCount');
      if (totalEl) totalEl.textContent = questionCards.length;
      document.getElementById('progressFill').style.width =
        Math.round((answered / questionCards.length) * 100) + '%';
      updateBlockStatus();
    }

    var assessmentInput = document.getElementById('assessment');
    var assessmentId = assessmentInput ? assessmentInput.value : '';

    // Indicador de guardado por pregunta
    function setCardSaveState(card, state) {
      var el = card.querySelector('.q-save');
      if (!el) {
        el = document.createElement('span');
        el.className = 'q-save';
        card.appendChild(el);
      }
      el.classList.remove('is-saving', 'is-saved', 'is-error');
      if (state === 'saving')      { el.textContent = 'Guardando…';        el.classList.add('is-saving'); }
      else if (state === 'saved')  { el.textContent = 'Guardado ✓';         el.classList.add('is-saved'); }
      else                         { el.textContent = 'No se pudo guardar'; el.classList.add('is-error'); }
    }

    // Guarda (upsert) en la BD la respuesta de una pregunta
    function saveAnswer(card) {
      if (!assessmentId) return;

      var report = card.dataset.report, block = card.dataset.block, question = card.dataset.question;
      var level  = getVal(report + '|' + block + '|' + question);
      if (level === null) return;

      setCardSaveState(card, 'saving');

      fetch('/api/v1/assessments/' + encodeURIComponent(assessmentId) + '/answers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          report:   Number(report),
          block:    Number(block),
          question: Number(question),
          level:    level,
          boost:    Number(card.dataset.boost) || 1
        })
      })
        .then(function (res) { setCardSaveState(card, res.ok ? 'saved' : 'error'); })
        .catch(function () { setCardSaveState(card, 'error'); });
    }

    // Recupera las respuestas ya guardadas y marca las opciones (sesión a medias)
    function restoreAnswers() {
      if (!assessmentId) { updateProgress(); return; }

      fetch('/api/v1/assessments/' + encodeURIComponent(assessmentId) + '/answers/search')
        .then(function (res) { return res.ok ? res.json() : { answers: [] }; })
        .then(function (body) {
          var answers = (body && body.answers) || [];
          answers.forEach(function (a) {
            var radios = document.getElementsByName(a.report + '|' + a.block + '|' + a.question);
            for (var i = 0; i < radios.length; i++) {
              if (parseInt(radios[i].value, 10) === parseInt(a.level, 10)) { radios[i].checked = true; break; }
            }
          });
          updateProgress();
        })
        .catch(function () { updateProgress(); });
    }

    // Al cambiar una opción: recalcular progreso y persistir esa respuesta
    diagForm.addEventListener('change', updateProgress);
    diagForm.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.q-card input[type="radio"]')) {
        var card = t.closest('.q-card');
        if (card) saveAnswer(card);
      }
    });

    restoreAnswers();

    // ── Contexto de cliente: validar completo y persistir al pasar a "Listado de preguntas" ──
    var ctxCustomerId = document.getElementById('ctx_customer') ? document.getElementById('ctx_customer').value : '';
    var ctxAlert = document.getElementById('ctxAlert');
    var CTX_REQUIRED = [
      { id: 'ctx_condos',               kind: 'number' },
      { id: 'ctx_employees',            kind: 'number' },
      { id: 'ctx_has_individual_seats', kind: 'select' },
      { id: 'ctx_is_synchronized',      kind: 'select' },
      { id: 'ctx_ai_tools_usage',       kind: 'text' },
      { id: 'ctx_repetitive_tasks',     kind: 'text' }
    ];

    function ctxFieldFilled(f) {
      var el = document.getElementById(f.id);
      if (!el) return true;
      var v = (el.value || '').trim();
      if (f.kind === 'number') return v !== '' && !isNaN(Number(v));
      return v !== '';
    }

    function validateContext() {
      var missing = 0;
      CTX_REQUIRED.forEach(function (f) {
        var el = document.getElementById(f.id);
        var ok = ctxFieldFilled(f);
        if (el) el.classList.toggle('is-invalid', !ok);
        if (!ok) missing++;
      });
      return missing === 0;
    }

    // Guarda los datos de contexto del cliente (reports.customer_data) vía add_data
    function saveContext() {
      if (!ctxCustomerId) return;
      var seats = document.getElementById('ctx_has_individual_seats').value;
      var sync  = document.getElementById('ctx_is_synchronized').value;
      fetch('/api/v1/customers/' + encodeURIComponent(ctxCustomerId) + '/data', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          employees:            Number(document.getElementById('ctx_employees').value) || 0,
          condos:               Number(document.getElementById('ctx_condos').value) || 0,
          has_individual_seats: seats === 'si',
          is_synchronized:      sync === 'si',
          ai_tools_usage:       document.getElementById('ctx_ai_tools_usage').value.trim(),
          repetitive_tasks:     document.getElementById('ctx_repetitive_tasks').value.trim(),
          comments:             document.getElementById('ctx_comments').value.trim()
        })
      }).catch(function () { /* guardado best-effort */ });
    }

    // Al corregir un campo se limpia su marca de error
    CTX_REQUIRED.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (el) el.addEventListener('change', function () {
        if (ctxFieldFilled(f)) el.classList.remove('is-invalid');
      });
    });

    // Intercepta en fase de captura para poder bloquear el cambio de pestaña si el contexto está incompleto
    var mainTabsNav = document.getElementById('mainTabsNav');
    if (mainTabsNav) {
      mainTabsNav.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.tab-btn[data-tab="preguntas"]') : null;
        if (!btn) return;

        if (!validateContext()) {
          e.stopPropagation();
          e.preventDefault();
          if (ctxAlert) ctxAlert.classList.remove('d-none');
          var ctxTab = mainTabsNav.querySelector('.tab-btn[data-tab="contexto-cliente"]');
          if (ctxTab) ctxTab.click();
          return;
        }

        if (ctxAlert) ctxAlert.classList.add('d-none');
        saveContext();
      }, true);
    }

    diagForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var invalid = questionCards.filter(function (card) { return !isAnswered(card); });

      questionCards.forEach(function (card) {
        card.classList.remove('is-invalid');
        var alertEl = card.querySelector('.alert');
        if (alertEl) alertEl.classList.add('d-none');
      });

      if (invalid.length) {
        invalid.forEach(function (card) {
          card.classList.add('is-invalid');
          var alertEl = card.querySelector('.alert');
          if (alertEl) alertEl.classList.remove('d-none');
        });

        var firstInvalid = invalid[0];
        var panel = firstInvalid.closest('.block-panel');
        if (panel) {
          var mainTab = document.querySelector('.tab-btn[data-tab="preguntas"]');
          if (mainTab && !mainTab.classList.contains('is-active')) mainTab.click();

          var sideBtn = document.querySelector('.side-nav-btn[data-block="' + panel.dataset.blockId + '"]');
          if (sideBtn && !sideBtn.classList.contains('is-active')) sideBtn.click();
        }
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var payload = { ctx: {}, answers: [] };
      payload.assessment               = document.getElementById('assessment').value;
      payload.ctx.customer             = document.getElementById('ctx_customer').value;
      payload.ctx.condos               = document.getElementById('ctx_condos').value;
      payload.ctx.employees            = document.getElementById('ctx_employees').value;
      payload.ctx.has_individual_seats = document.getElementById('ctx_has_individual_seats').value;
      payload.ctx.is_synchronized      = document.getElementById('ctx_is_synchronized').value;
      payload.ctx.ai_tools_usage       = document.getElementById('ctx_ai_tools_usage').value.trim();
      payload.ctx.repetitive_tasks     = document.getElementById('ctx_repetitive_tasks').value.trim();
      payload.ctx.comments             = document.getElementById('ctx_comments').value.trim();

      questionCards.forEach(function (card) { 
        payload.answers.push({
          question: card.dataset.question,
          block: card.dataset.block,
          report:card.dataset.report,
          boost: card.dataset.boost,
          level: getVal(`${card.dataset.report}|${card.dataset.block}|${card.dataset.question}`)
        })
       });

      var input    = document.createElement('input');
      input.type   = 'hidden';
      input.name   = 'payload';
      input.value  = JSON.stringify(payload);
      var form     = document.createElement('form');
      form.method  = 'POST';
      form.action  = `/reports/maturity/result/${payload.ctx.customer}/${payload.assessment}`;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    });
  }

  /* ════════════════════════════════════════════════════════════
     BUSCADOR Y ALTA DE CLIENTE (homepage.handlebars)
     ════════════════════════════════════════════════════════════ */
  var modeButtons = document.querySelectorAll('.mode-btn');
  if (modeButtons.length) {
    var modePanels = document.querySelectorAll('.mode-panel');

    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modeButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        modePanels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.id === (btn.dataset.mode === 'search' ? 'panelSearch' : 'panelCreate'));
        });
      });
    });
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json()
        .catch(function () { return {}; })
        .then(function (body) { return { ok: res.ok, body: body }; });
    });
  }

  var searchForm = document.getElementById('searchForm');
  if (searchForm) {
    var searchInput   = document.getElementById('searchInput');
    var searchStatus  = document.getElementById('searchStatus');
    var searchResults = document.getElementById('searchResults');

    var localizarEl   = document.getElementById('localizar-cliente');
    var MATURITY_REPORT = localizarEl ? localizarEl.dataset.report : '';

    var STATUS_LABEL = { in_progress: 'En curso', completed: 'Completado', cancelled: 'Cancelado' };

    function showSearchStatus(message) {
      searchResults.innerHTML = '';
      searchStatus.textContent = message;
      searchStatus.classList.remove('d-none');
    }

    function fmtDate(value) {
      try {
        return new Date(value).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
      } catch (e) {
        return value;
      }
    }

    // Crea un nuevo assessment (in_progress) y navega a la recogida de respuestas
    function createAssessment(customer, btn) {
      btn.setAttribute('disabled', 'disabled');
      fetchJSON('/api/v1/assessments', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ report: Number(MATURITY_REPORT), customer: customer })
      })
        .then(function (result) {
          if (!result.ok || !result.body || !result.body.assessment) { throw new Error('assessment-failed'); }
          window.location.href = '/reports/maturity/evaluate/' + customer + '?assessment=' + result.body.assessment;
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          showSearchStatus('No se ha podido crear el reporte. Inténtalo de nuevo.');
        });
    }

    // Lista de assessments previos del cliente (continuar / ver informe)
    function renderAssessments(customer, assessments) {
      var list = document.createElement('div');
      list.className = 'assessment-list';

      assessments.forEach(function (a) {
        var item = document.createElement('div');
        item.className = 'assessment-item';

        var meta = document.createElement('div');
        meta.className = 'assessment-meta';

        var when = document.createElement('span');
        when.className = 'assessment-when';
        when.textContent = fmtDate(a.datetime);
        meta.appendChild(when);

        var status = document.createElement('span');
        status.className = 'assessment-status st-' + a.status;
        status.textContent = STATUS_LABEL[a.status] || a.status;
        meta.appendChild(status);

        if (a.score !== null && a.score !== undefined) {
          var score = document.createElement('span');
          score.className = 'assessment-score';
          score.textContent = a.score + ' / 4';
          meta.appendChild(score);
        }

        var action = document.createElement('button');
        action.type = 'button';
        action.className = 'btn btn-light';

        if (a.status === 'in_progress') {
          action.textContent = 'Continuar';
          action.addEventListener('click', function () {
            window.location.href = '/reports/maturity/evaluate/' + customer + '?assessment=' + a.assessment;
          });
        } else {
          action.textContent = 'Ver informe';
          action.addEventListener('click', function () {
            window.location.href = `/reports/maturity/result/${customer}/${a.assessment}`;
          });
        }

        item.appendChild(meta);
        item.appendChild(action);
        list.appendChild(item);
      });

      return list;
    }

    // se pintan los clientes resultado de la búsqueda
    function renderResults(customers) {
      searchStatus.classList.add('d-none');
      searchResults.innerHTML = '';

      customers.forEach(function (c) {
        var card = document.createElement('div');
        card.className = 'customer-card';

        var top = document.createElement('div');
        top.className = 'customer-card-top';

        var info = document.createElement('div');

        var name = document.createElement('div');
        name.className = 'customer-name';
        name.textContent = c.name || 'Sin nombre';
        info.appendChild(name);

        var metaParts = [];
        if (c.code)    metaParts.push('Código ' + c.code);
        if (c.license) metaParts.push('Licencia ' + c.license);
        if (c.city)    metaParts.push(c.city);

        if (metaParts.length) {
          var meta = document.createElement('div');
          meta.className = 'customer-meta';
          metaParts.forEach(function (text) {
            var span = document.createElement('span');
            span.textContent = text;
            meta.appendChild(span);
          });
          info.appendChild(meta);
        }

        var newBtn = document.createElement('button');
        newBtn.type = 'button';
        newBtn.className = 'btn btn-primary';
        newBtn.textContent = 'Nuevo reporte';
        newBtn.addEventListener('click', function () { createAssessment(c.customer, newBtn); });

        top.appendChild(info);
        top.appendChild(newBtn);
        card.appendChild(top);

        var assessments = Array.isArray(c.assessments) ? c.assessments : [];
        if (assessments.length) {
          card.appendChild(renderAssessments(c.customer, assessments));
        }

        searchResults.appendChild(card);
      });
    }

    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var q = searchInput.value.trim();
      if (!q) {
        showSearchStatus('Escribe al menos un criterio de búsqueda.');
        return;
      }

      showSearchStatus('Buscando…');

      fetchJSON('/api/v1/customers/search?q=' + encodeURIComponent(q))
        .then(function (result) {
          var customers = result.body && result.body.customers;
          if (!result.ok || !customers || !customers.length) {
            showSearchStatus('No se han encontrado clientes con ese criterio.');
            return;
          }
          renderResults(customers);
        })
        .catch(function () {
          showSearchStatus('Error al buscar clientes. Inténtalo de nuevo.');
        });
    });
  }

  var createForm = document.getElementById('createForm');
  if (createForm) {
    var createAlert = document.getElementById('createAlert');
    var createBtn   = document.getElementById('createBtn');

    function showCreateAlert(message) {
      createAlert.textContent = message;
      createAlert.classList.remove('d-none');
    }

    createForm.addEventListener('submit', function (e) {
      e.preventDefault();

      createAlert.classList.add('d-none');

      var name = document.getElementById('c_name').value.trim();
      if (!name) {
        showCreateAlert('El nombre del despacho es obligatorio.');
        return;
      }

      var payload = {
        code:       document.getElementById('c_code').value || null,
        license:    document.getElementById('c_license').value || null,
        name:       name,
        vat_number: document.getElementById('c_vatNumber').value.trim() || null,
        address:    document.getElementById('c_address').value.trim() || null,
        city:       document.getElementById('c_city').value.trim() || null,
        province:   document.getElementById('c_province').value.trim() || null,
        zipcode:    document.getElementById('c_zipcode').value.trim() || null,
        country:    document.getElementById('c_country').value.trim() || null,
        details:    { notes: document.getElementById('c_details').value.trim() }
      };

      createBtn.setAttribute('disabled', 'disabled');

      fetchJSON('/api/v1/customers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (result) {
          if (!result.ok || !result.body || !result.body.customer) {
            throw new Error('create-failed');
          }
          //goToEvaluate(result.body.customer);
          window.location.href = `/reports/maturity/evaluate/${result.body.customer}`
        })
        .catch(function (err) {
          createBtn.removeAttribute('disabled');
          showCreateAlert('No se ha podido crear el cliente. Revisa los datos e inténtalo de nuevo.');
        });


    });
  }

})();
